module.exports = __webpack_public_path__ + "static/media/light.8c87d4e1.png";